module.exports = __webpack_public_path__ + "media/fonts/fa-regular-400-78f8395a45f69b89cf8828a6bb3b4933.ttf";